function getEnv(name: string): string {
    // @ts-ignore
    return window?.envConfig?.[name] || process.env[name] || "";
}

function getCulture(): string {
    return getEnv("VUE_APP_CULTURE");
}

function getApiBaseUrl(): string {
    return getEnv("VUE_APP_API_BASE_URL");
}

function getApiKey(): string {
    return getEnv("VUE_APP_API_KEY");
}

function getContactPhoneNumber(): string {
    return getEnv("VUE_APP_CONTACT_PHONE_NUMBER");
}

function getContractWithdrawalContactPhoneNumber1(): string {
    return getEnv("VUE_APP_CONTRACT_WITHDRAWAL_CONTACT_PHONE_NUMBER_1");
}

function getContractWithdrawalContactPhoneNumber2(): string {
    return getEnv("VUE_APP_CONTRACT_WITHDRAWAL_CONTACT_PHONE_NUMBER_2");
}

function getMappLink(): string {
    return getEnv("VUE_APP_MAPP_LINK");
}

export {
    getCulture,
    getApiBaseUrl,
    getApiKey,
    getContactPhoneNumber,
    getContractWithdrawalContactPhoneNumber1,
    getContractWithdrawalContactPhoneNumber2,
    getMappLink
};
